import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PreviewButton from '../PreviewButton';

export default class extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    previewButtonProps: PropTypes.object,
    children: PropTypes.object.isRequired,
  }

  static defaultProps = {
    previewButtonProps: undefined,
  }

  renderPreviewButton() {
    if (this.props.previewButtonProps) {
      return (
        <div className="u-float-right">
          <PreviewButton {...this.props.previewButtonProps} />
        </div>
      );
    }
  }

  render() {
    return (
      <div className="u-mt-4">
        <h2>
          {this.props.title}
          {this.renderPreviewButton()}
        </h2>
        {this.props.children}
      </div>
    );
  }
}
